import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { trackEvent } from 'dibs-tracking';
import { sessionStorage } from 'dibs-browser-storage';

import FavNotificationsSpinner from './FavNotificationsSpinner';
import FavNotificationsTileList from './FavNotificationsTileList';
import FavNotificationsEmpty from './FavNotificationsEmpty';
import DropdownHeader from '../Dropdown/DropdownHeader';
import DropdownBody from '../Dropdown/DropdownBody';

import { VIEW_ALL, EMPTY } from './favNotificationsConstants';
import {
    getNotificationClickedTrackingObj,
    getNotificationsDisplayedTrackingObj,
    indicatorShownTrackingObj
} from './trackingHelpers.es';
import style from './FavNotifications-style.scss';

const INDICATOR_SHOWN_TRACKED = 'indicatorShownTracked';

const trackNewEventsIndicatorShown = () => {
    if (!sessionStorage.getItem(INDICATOR_SHOWN_TRACKED)) {
        trackEvent(indicatorShownTrackingObj());
        sessionStorage.setItem(INDICATOR_SHOWN_TRACKED, true);
    }
};

const toggleBodyScrolling = () => {
    document.body.classList.toggle(style.stopScrolling);
};

const trackClick = () => {
    trackEvent(getNotificationClickedTrackingObj(VIEW_ALL));
};

const FavNotifications = props => {
    const { hasNewEvents, hasUserId, favoriteNotificationsTiles, favoritesUrl } = props;
    const { tiles } = favoriteNotificationsTiles || {};

    if (hasNewEvents) {
        trackNewEventsIndicatorShown();
    }

    const emptyState = !hasUserId || (hasUserId && tiles && !tiles.length);

    if (emptyState) {
        trackEvent(getNotificationsDisplayedTrackingObj({
            types: [
                { type: EMPTY, displayed: true }
            ]
        }));
    }

    return (
        <div onMouseEnter={toggleBodyScrolling} onMouseLeave={toggleBodyScrolling}>
            {emptyState ?
                <FavNotificationsEmpty /> :
                <DropdownHeader
                    title={<FormattedMessage id='dbl.Header.FavNotifications.title' defaultMessage='Favorites'/>}
                    link={<FormattedMessage id='dbl.Header.FavNotifications.link' defaultMessage='View All'/>}
                    href={favoritesUrl}
                    onClick={trackClick}
                />
            }
            {!emptyState ?
                <DropdownBody>
                    {!tiles ?
                        <FavNotificationsSpinner/> :
                        <FavNotificationsTileList
                            tiles={tiles}
                            favoritesUrl={favoritesUrl}
                            hasNewEvents={hasNewEvents}
                        />
                    }
                </DropdownBody> :
                null
            }
        </div>
    );
};

FavNotifications.propTypes = {
    hasNewEvents: PropTypes.bool,
    hasUserId: PropTypes.bool,
    favoriteNotificationsTiles: PropTypes.object,
    favoritesUrl: PropTypes.string
};

FavNotifications.defaultProps = {
    hasNewEvents: false
};

export default createFragmentContainer(
    FavNotifications,
    {
        favoriteNotificationsTiles: graphql.experimental`
            fragment FavNotifications_favoriteNotificationsTiles on FavoriteNotifications
            @argumentDefinitions(
                createdAfter: {type: "String!", defaultValue: ""}
                eventsLimit: {type: "Int!", defaultValue: 0}
                notificationItemsLimit: {type: "Int!", defaultValue: 0}
            ) {
                tiles: notificationsList(
                    createdAfter: $createdAfter
                    notificationsLimit: $eventsLimit
                    notificationItemsLimit: $notificationItemsLimit
                ) {
                    ...FavNotificationsTileList_tiles
                }
            }
        `
    }
);



// WEBPACK FOOTER //
// ./src/components/FavNotifications/FavNotifications.jsx